import axios from 'axios'

export default {
    loadLocation(locationId) {
        // eslint-disable-next-line
        return axios.get(`${process.env.VUE_APP_API_URL}/locations/`+locationId);
    },
    updateLocation(data) {
        // eslint-disable-next-line
        return axios.put(`${process.env.VUE_APP_API_URL}/locations/`+data.id, data.item);
    },
    getPdf(locationId, dates) {
        // eslint-disable-next-line
        return axios.get(`${process.env.VUE_APP_API_URL}/pdf/`+locationId+'/'+dates, {responseType: 'arraybuffer'});
    }
}
